import { ChatMessage } from '@secca/shared/models/atlas/atlas-chatbot.model';

export function createInitialMessages(userName: string, timestamp: string = createMessageTimestamp()): ChatMessage[] {
  return [{
    author: 'bot',
    text: `Hello ${userName}, how can I help you? 🙂`,
    timestamp,
    feedbackEnabled: false,
    reaction: null,
    reactionComment: ''
  }];
}

export function createBotMessage(
  html: string,
  timestamp: string = createMessageTimestamp()
): ChatMessage {
  return {
    author: 'bot',
    text: '',
    timestamp,
    html,
    feedbackEnabled: true,
    reaction: null,
    reactionComment: ''
  };
}

export function createSystemErrorMessage(
  text: string,
  timestamp: string = createMessageTimestamp()
): ChatMessage {
  return {
    author: 'system',
    text,
    timestamp,
    feedbackEnabled: false,
    reaction: null,
    reactionComment: ''
  };
}

export function getMessageContextTooltip(message: ChatMessage): string | null {
  if (!message?.caseContextModeEnabled) {
    return null;
  }

  const enabledFields = message.caseContextEnabledFields || [];
  const enabledFieldsText = enabledFields.length > 0 ? enabledFields.join(', ') : 'None';
  return `Enabled fields: ${enabledFieldsText}`;
}

export function createMessageTimestamp(): string {
  return new Date().toISOString();
}
